import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const courseTypes = [{
  title: "Municipal Courses",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/municipal_course_aerial.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/municipal_course_aerial.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/municipal_course_aerial.png-wvc-sizes",
    alt: "Aerial view of a municipal golf course"
  }
}, {
  title: "Daily Fee Courses",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/daily_fee_course_aerial.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/daily_fee_course_aerial.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/daily_fee_course_aerial.png-wvc-sizes",
    alt: "Aerial view of a daily fee golf course"
  }
}, {
  title: "Semi-Private Clubs",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/semi_private_club_aerial.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/semi_private_club_aerial.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/semi_private_club_aerial.png-wvc-sizes",
    alt: "Aerial view of a semi-private golf club"
  }
}, {
  title: "Private Clubs",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/private_club_aerial.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/private_club_aerial.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/private_club_aerial.png-wvc-sizes",
    alt: "Aerial view of a private golf club"
  }
}, {
  title: "Golf Resorts",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/golf_resort_aerial.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/golf_resort_aerial.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/golf_resort_aerial.png-wvc-sizes",
    alt: "Aerial view of a luxury golf resort"
  }
}, {
  title: "Practice Facilities",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/practice_facility_aerial.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/practice_facility_aerial.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675093/img/practice_facility_aerial.png-wvc-sizes",
    alt: "Aerial view of a golf practice facility and driving range"
  }
}];
export default function CourseTypeShowcase() {
  return <section id="coursetypeshowcase" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="mx-auto max-w-3xl text-center mb-16">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            We Work With Golf Courses Of All Types
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            From local municipal courses to destination clubs, every golf course deserves professional media that showcases its personality, layout, atmosphere, and experience.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {courseTypes.map((course, i) => <Card key={i} data-index={i} className="overflow-hidden border-secondary/30 hover:border-secondary transition-colors duration-300 shadow-sm hover:shadow-md group">
              <AspectRatio ratio={16 / 9} className="overflow-hidden bg-muted">
                <img src={course.image.src} data-wvc-srcset={course.image.srcset} data-wvc-sizes={course.image.sizes} alt={course.image.alt} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                {}
                <div className="absolute inset-0 bg-primary/10 group-hover:bg-transparent transition-colors duration-500" />
              </AspectRatio>
              <CardHeader className="text-center bg-card relative z-10">
                <CardTitle className="font-default text-xl text-foreground">
                  {course.title}
                </CardTitle>
              </CardHeader>
            </Card>)}
        </div>

        {}
        <div className="mx-auto max-w-4xl text-center bg-primary/5 rounded-2xl p-8 md:p-12 border border-secondary/20">
          <h3 className="font-default text-2xl md:text-3xl font-semibold text-foreground mb-6">
            Every Golf Course Has a Story Worth Showing
          </h3>
          <div className="space-y-6 text-muted-foreground text-base md:text-lg mb-10">
            <p className="font-medium text-foreground">
              Professional golf course media shouldn’t be limited to only PGA Tour venues and luxury resorts.
            </p>
            <p>Trow Golf Media helps courses of all sizes modernize how they’re seen online through cinematic aerial visuals and affordable media solutions designed to elevate presentation without requiring a massive marketing budget.</p>
            <p>
              We offer flexible media packages designed to help golf courses of every size improve visibility, presentation, and marketing.
            </p>
          </div>
          
          <Button asChild size="lg" variant="outline" className="border-secondary text-foreground hover:bg-secondary hover:text-secondary-foreground transition-all duration-300 shadow-sm">
            <Link to="/RequestAQuotePage">
              Request a Custom Quote
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}